import React, {useCallback, useState} from 'react'
import {REGEX_LEADING_ZERO} from 'consts'
import {requestData} from 'services'
import {useTranslation} from 'i18n'
import {formatPhoneNumber} from 'utils'
import {useSelector} from 'lib/redux'
import {GiftShopTemplateOTPModal} from '../../../template'
import {GiftShopEditProfileOTPModalProps} from './GiftShopEditProfileModalProps'

export default function GiftShopEditProfileVerifyOTPModal({
  verificationMethod,
  onCancel,
  onResend,
  onSuccess,
  onFailed,
}: GiftShopEditProfileOTPModalProps) {
  const {translate} = useTranslation()
  const {phoneCode, phoneNumber} = useSelector('userNewPhone') || {}
  const {phone_code: oldPhoneCode, phone_number: oldPhoneNumber} =
    useSelector('user') || {}
  const {phoneOTPTime} = useSelector('lastUserState')
  const {isOldPhoneConfirmed, verifMethodPhone} = useSelector(
    'editProfileState',
  )

  const stateIncorrect = useState(false)
  const setIncorrect = stateIncorrect[1]
  const [errorCode, setErrorCode] = useState(200)

  const handleVerify = useCallback(
    (otp: string) => {
      if (isOldPhoneConfirmed) {
        requestData('member_2fa_edit_phone_verify_new', {
          data: {code: otp},
          onRequestSuccess: ({status, data: {detail}}) => {
            if (status === 200) {
              setIncorrect(false)
              onSuccess()
            } else if (status === 400 && detail) {
              if (detail.code === 'code does not match') {
                setErrorCode(404)
                setIncorrect(true)
              }
            } else if (status === 410) {
              setErrorCode(410)
              setIncorrect(false)
            } else {
              onFailed()
            }
          },
        })
      } else {
        requestData('member_2fa_edit_phone_verify_current', {
          data: {code: otp},
          onRequestSuccess: ({status, data: {detail}}) => {
            if (status === 200) {
              setIncorrect(false)
              onSuccess()
            } else if (status === 400 && detail) {
              if (detail.code === 'code does not match') {
                setErrorCode(404)
                setIncorrect(true)
              }
            } else if (status === 410) {
              setErrorCode(410)
              setIncorrect(false)
            } else {
              onFailed()
            }
          },
        })
      }
    },
    [isOldPhoneConfirmed, onFailed, onSuccess, setIncorrect],
  )

  return (
    <GiftShopTemplateOTPModal
      stateError={stateIncorrect}
      dataToVerify={
        oldPhoneCode && oldPhoneNumber && !isOldPhoneConfirmed
          ? `+${oldPhoneCode} ${formatPhoneNumber(
              oldPhoneNumber.replace(REGEX_LEADING_ZERO, ''),
            )}`
          : phoneCode &&
            phoneNumber &&
            `+${phoneCode} ${formatPhoneNumber(
              phoneNumber.replace(REGEX_LEADING_ZERO, ''),
            )}`
      }
      verificationMethod="phone"
      timeRemaining={phoneOTPTime}
      onCancel={onCancel}
      onVerify={handleVerify}
      onResend={onResend}
      textAvailable={
        !isOldPhoneConfirmed
          ? translate('giftShop:editCredentialOtpResendAvailable')
          : undefined
      }
      textCooldown={
        !isOldPhoneConfirmed
          ? 'giftShop:editCredentialOtpResendCooldown'
          : undefined
      }
      bottomText={translate(
        verifMethodPhone === 'phone' || verificationMethod === 'sms'
          ? isOldPhoneConfirmed
            ? 'giftShop:newPhone'
            : 'giftShop:oldPhone'
          : isOldPhoneConfirmed
          ? 'giftShop:newWhatsapp'
          : 'giftShop:oldWhatsapp',
      )}
      footerText={
        errorCode === 410 ? translate('giftShop:codeExpired') : undefined
      }
    />
  )
}
